import React from 'react';
import Icon, {
    FacebookFilled,
    XOutlined,
    InstagramFilled,
    YoutubeFilled,
    TikTokFilled,
} from '@ant-design/icons';

import InstagramOutlined from '../components/posts/icons/InstagramOutlined';
import InstagramOutlinedBlue from '../components/posts/icons/InstagramOutlinedBlue';
import TiktokOutlined from '../components/posts/icons/TiktokOutlined';
import TiktokOutlinedBlue from '../components/posts/icons/TiktokOutlinedBlue';
import X2Outlined from '../components/posts/icons/XOutlined';
import XOutlinedBlue from '../components/posts/icons/XOutlinedBlue';
import YoutubeOutline from '../components/posts/icons/YoutubeOutlined';
import YoutubeOutlinedBlue from '../components/posts/icons/YoutubeOutlinedBlue';
import FacebookOutlined from '../components/posts/icons/FacebookOutlined';
import FacebookOutlinedBlue from '../components/posts/icons/FacebookOutlinedBlue';

export const getIcon = (lowerSocName: string) => {
    const iconStyle = { fontSize: '18px', color: '#00000073' };

    switch (lowerSocName) {
        case 'instagram':
            return <InstagramFilled style={iconStyle} />;
        case 'tiktok':
            return <TikTokFilled style={iconStyle} />;
        case 'x':
            return <XOutlined style={iconStyle} />;
        case 'youtube':
            return <YoutubeFilled style={iconStyle} />;
        case 'facebook':
            return <FacebookFilled style={iconStyle} />;
        default:
            return <InstagramFilled style={iconStyle} />;
    }
};

export const getCustomIcon = (lowerSocName: string, isBigger?: boolean) => {
    const iconStyle: React.CSSProperties = {
        display: 'flex',
        width: '20px',
        height: '20px',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '200px',
        background: '#009fdf',
        borderRadius: '50%',
    };
    let icon;

    switch (lowerSocName) {
        case 'instagram':
            icon = isBigger ? InstagramOutlinedBlue : InstagramOutlined;
            break;
        case 'tiktok':
            icon = isBigger ? TiktokOutlinedBlue : TiktokOutlined;
            break;
        case 'x':
        case 'x-twitter':
            icon = isBigger ? XOutlinedBlue : X2Outlined;
            break;
        case 'youtube':
            icon = isBigger ? YoutubeOutlinedBlue : YoutubeOutline;
            break;
        case 'facebook':
            icon = isBigger ? FacebookOutlinedBlue : FacebookOutlined;
            break;
        default:
            icon = isBigger ? InstagramOutlinedBlue : InstagramOutlined;
            break;
    }

    return <Icon style={!isBigger ? iconStyle : null} component={icon} />;
};
